import React, { useContext, useRef, useEffect } from 'react';
import useNebula from 'hooks/useNebula';
import AppContext from '../AppContext';

const SelectionToolbar = () => {
  const qlikApp = useContext(AppContext);
  const nebula = useNebula(qlikApp);

  const selectionRef = useRef();

  useEffect(async () => {
    if (!nebula) return;
    async function render() {
      const selections = await nebula.selections();
      selections.mount(selectionRef.current);
    }
    render();
  }, [nebula]);

  return (
    <div ref={selectionRef} style={{ height: 55 }} />
  );
};

export default SelectionToolbar;
